angular.module('tf.services')

    .factory('C3Service', [
        function () {

            var service = {};


            service.pie = function(values){
                var data = [];
                if(values) {
                    for (var val in values) {
                        data.push([val].concat([_.reduce(_.values(values[val]), function (sum, num) {
                            return sum + num;
                        }, 0)]));
                    }
                }
                return _.sortBy(data, function(val){return -val[1];});

            };

            service.line = function(series, values){
                var data = {};
                if(series && values) {
                    for (var i = 0; i < series.length; i++) {
                        var item = series[i];
                        for (var key in values) {
                            if (!data[key]) {
                                data[key] = [values[key][item]];
                            } else {
                                data[key].push(values[key][item]);
                            }
                        }
                    }
                    data.x = series;
                }
                // return objectToArrays(data);
                return _.sortBy(objectToArrays(data), function(val){return -_.sum(val.slice(1, val.length));});
            };

            service.bar = function(values){
                var data = [];
                if(values) {
                    for (var val in values) {
                        data.push([val].concat([_.reduce(_.values(values[val]), function (sum, num) {
                            return sum + num;
                        }, 0)]));
                    }
                }
                return _.sortBy(data, function(val){return -val[1];});
            };

            service.getCategories = function(values){
                return Object.keys(values);
            };

            service.getSortedCategories = function (values) {
                return _.chain(values).pairs().sortBy(function(val){return -_.sum(Object.values(val[1]));}).map(function(val){return val[0];}).value();
            };

            function objectToArrays(data){
                return _.reduce(data, function(result, val, key){
                    result.push([key].concat(val));
                    return result;
                },[]);
            }



            return service;
        }])
;
